module.exports = __webpack_public_path__ + "img/td.710e0dac.svg";